import React, { useEffect } from 'react';
import { StyleSheet, Page } from '@react-pdf/renderer';
import StudentSummaryPage from './studentSummaryPage';

const StudentSummary = (props) => {
    const { bgColor } = props;
    useEffect(() => {
        // console.log('StudentSummary called');
    }, []);

    const styles = StyleSheet.create({
        page: {
            position: "relative",
            fontSize: 12,
            padding: 20,
            backgroundColor: bgColor
        },
    });

    const lstSubject = [
        { subject: "Language 1", rating: { a: 20, s: 20, c: 10 }, feedback: "Overall performance was okay. They have a good grasp of this language." },
        { subject: "Language 2", rating: { a: 10, s: 30, c: 20 }, feedback: "Shows improvement but needs to work on comprehension skills." },
        { subject: "Language 3", rating: { a: 30, s: 10, c: 20 }, feedback: "Fluent in speaking but writing skills need attention." },
        { subject: "Mathematics", rating: { a: 20, s: 20, c: 10 }, feedback: "Good understanding, but needs more practice." },
        { subject: "Science", rating: { a: 10, s: 30, c: 20 }, feedback: "Shows improvement but needs to work on concepts." },
        // { subject: "Art", rating: { a: 30, s: 10, c: 20 }, feedback: "Creative and expressive, but needs refinement." },
        { subject: "Overall", rating: { a: 20, s: 20, c: 10 }, feedback: "Overall performance was okay. Needs to balance strengths and weaknesses.", isOverall: true }
    ];

    const chunkArray = (arr, size) => {
        return arr.reduce((acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]), []);
    };

    const subjectPages = chunkArray(lstSubject, 3);

    return (
        <>
            {subjectPages.map((subjects, index) => (
                <Page key={index} style={[styles.page, { backgroundColor: '#fff' }]}>
                    <StudentSummaryPage
                        subjectObjR1={subjects[0] || null}
                        subjectObjR2={subjects[1] || null}
                        subjectObjR3={subjects[2] || null}
                        isFirstPage={index === 0}
                    />
                </Page>
            ))}
        </>
    );
};

export default StudentSummary;
